export const parseIntFromString = function(val, defaultVal) {
	let result = defaultVal;

	if (typeof val === 'number' || typeof val === 'string') {
		result = parseInt(val);
	}

	if (isNaN(result)) {
		result = defaultVal;
	}

	return result;
};

export const parseBool = function(val, defaultVal) {
	let result = false;
	let defaultWhenEmpty = false;

	if (typeof val === 'boolean') {
		result = val;
	} else {
		// eslint-disable-next-line no-undef
		if (arguments.length > 1) {
			defaultWhenEmpty = defaultVal;
		}

		if (val !== undefined && val !== null && val !== '') {
			const stringVal = (val + '').toLowerCase();
			result = stringVal === 'true' || stringVal === '1';
		} else {
			result = defaultWhenEmpty;
		}
	}

	return result;
};
